// Drag auto-scroll geometry (Scrolling Kanban #491). Pure: given the pointer position on
// one axis and the visible bounds of a scroll container on that axis, returns the scroll
// velocity in px per frame (negative = towards the start, positive = towards the end, 0 =
// outside the edge zones).
//
// The edge zone sits INSIDE the container (so scrolling starts well before the pointer
// reaches the window edge — on macOS pushing past the window edge switches Spaces), and is
// clamped to the viewport, so a container wider than the window still triggers before the
// window's own edge. Speed grows with the depth into the zone and is capped once the
// pointer is at — or past — the edge, so holding a ticket there keeps scrolling at full
// speed until the container's end.

export const EDGE_ZONE_PX = 72;
export const MAX_SPEED_PX = 18;
export const MIN_SPEED_PX = 2;

export function edgeVelocity(pos, start, end, viewportEnd, {
    zone = EDGE_ZONE_PX, maxSpeed = MAX_SPEED_PX, minSpeed = MIN_SPEED_PX,
} = {}) {
    const lo = Math.max(start, 0);
    const hi = Math.min(end, viewportEnd);
    if (!(hi > lo)) return 0;
    // A container too small for two full zones gets proportionally smaller ones.
    const z = Math.min(zone, (hi - lo) / 3);
    if (z <= 0) return 0;
    const speed = (depth) => {
        const f = Math.min(1, depth / z);
        return Math.round(minSpeed + (maxSpeed - minSpeed) * f * f);
    };
    if (pos < lo + z) return -speed(lo + z - pos);
    if (pos > hi - z) return speed(pos - (hi - z));
    return 0;
}

// Whether a velocity can actually move the container (not already at that end).
export function canScroll(velocity, scrollPos, scrollSize, clientSize) {
    if (velocity < 0) return scrollPos > 0;
    if (velocity > 0) return scrollPos + clientSize < scrollSize - 1;
    return false;
}
